import { AprovacaoPixComponent } from './aprovacao-pix/aprovacao-pix.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackofficeComponent } from './backoffice.component';
import { RouterModule, Routes } from '@angular/router';
import { GestaoUsuarioBackofficeComponent } from './gestao-usuario-backoffice/gestao-usuario-backoffice.component';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';
import { CadastroUsuarioBackofficeComponent } from './cadastro-usuario-backoffice/cadastro-usuario-backoffice.component';
import { AlteracaoUsuarioBackofficeComponent } from './alteracao-usuario-backoffice/alteracao-usuario-backoffice.component';
import { AutorizarNovoDispositivoComponent } from './autorizar-novo-dispositivo/autorizar-novo-dispositivo.component';
import { AlteracaoCadastralClienteComponent } from './alteracao-cadastral-cliente/alteracao-cadastral-cliente.component';
import { CriarSenhaTemporariaComponent } from './criar-senha-temporaria/criar-senha-temporaria.component';
import { ExtratoContaBmpComponent } from './extrato-conta-bmp/extrato-conta-bmp.component';
import { ExtratoContaOrbitalComponent } from './extrato-conta-orbital/extrato-conta-orbital.component';
import { ExtratoContaUsuarioComponent } from './extrato-conta-usuario/extrato-conta-usuario.component';
import { ConsultaFinanceiraComponent } from './consulta-financeira/consulta-financeira.component';
import { GestaoOnboardingComponent } from './gestao-onboarding/gestao-onboarding.component';
import { JobSchedulerComponent } from './job-scheduler/job-scheduler.component';
import { GestaoOnboardingDetailsComponent } from './gestao-onboarding-details/gestao-onboarding-details.component';
import { GestaoRequisitarCartoesComponent } from './gestao-requisitar-cartoes/gestao-requisitar-cartoes.component';
import { GestaoRequisitarCartoesDetailsComponent } from './gestao-requisitar-cartoes-details/gestao-requisitar-cartoes-details.component';
import { ConsultaMovimentacoesPixComponent } from './consulta-movimentacoes-pix/consulta-movimentacoes-pix.component';
import { RestringirMccProdutoComponent } from './restringir-mcc-produto/restringir-mcc-produto.component';
import { RestringirMccProdutoClienteCartaoComponent } from './restringir-mcc-produto-cliente-cartao/restringir-mcc-produto-cliente-cartao.component';
import { RestringirMccProdutoClienteCartaoEditComponent } from './restringir-mcc-produto-cliente-cartao/restringir-mcc-produto-cliente-cartao-edit/restringir-mcc-produto-cliente-cartao-edit.component';
import { RestringirMccClienteComponent } from './restringir-mcc-cliente/restringir-mcc-cliente.component';
import { ImportarCartaoComponent } from './gestao-estoque/importar-cartao/importar-cartao.component';

const routes: Routes = [{
  path: '',
  component: BackofficeComponent,
  children: [
    {
      path: 'alteracao-cadastral-cliente',
      component: AlteracaoCadastralClienteComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['ATUALIZACAO_CADASTRAL']},
    },
    {
      path: 'gestao-usuario-backoffice',
      component: GestaoUsuarioBackofficeComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['GESTAO_USUARIO_BACKOFFICE']},
    },
    {
      path: 'cadastro-usuario-backoffice',
      component: CadastroUsuarioBackofficeComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['GESTAO_USUARIO_BACKOFFICE']},
    },
    {
      path: 'alteracao-usuario-backoffice',
      component: AlteracaoUsuarioBackofficeComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['GESTAO_USUARIO_BACKOFFICE']},
    },
    {
      path: 'autorizar-novo-dispositivo',
      component: AutorizarNovoDispositivoComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['AUTORIZAR_NOVO_DISPOSITIVO']},
    },
    {
      path: 'criar-senha-temporaria',
      component: CriarSenhaTemporariaComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['CRIAR_SENHA_TEMPORARIA']},
    },
    {
      path: 'extrato-conta-bmp',
      component: ExtratoContaBmpComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['EXTRATO_CONTA_BMP']},
    },
    {
      path: 'extrato-conta-orbital',
      component: ExtratoContaOrbitalComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['EXTRATO_CONTA_ORBITAL']},
    },
    {
      path: 'extrato-conta-usuario',
      component: ExtratoContaUsuarioComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['EXTRATO_CONTA_ORBITAL']},
    },
    {
      path: 'consulta-financeira',
      component: ConsultaFinanceiraComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['CONSULTA_FINANCEIRA']},
    },
    {
      path: 'gestao-onboarding',
      component: GestaoOnboardingComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['GESTAO_ONBOARDING']},
    },
    {
      path: 'job-scheculer',
      component: JobSchedulerComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['JOB_SCHEDULER']},
    },
    {
      path: 'consulta-movimentacoes-pix',
      component: ConsultaMovimentacoesPixComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['EXTRATO_CONTA_BMP']},
    },
    {
      path: 'aprovacao-pix',
      component: AprovacaoPixComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['LIMITES_PIX']},
    },
    {
      path: 'gestao-onboarding-details',
      component: GestaoOnboardingDetailsComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['GESTAO_ONBOARDING']},
    },
    {
      path: 'gestao-requisitar-cartoes',
      component: GestaoRequisitarCartoesComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['GESTAO_REQUISITAR_CARTOES']},
    },
    {
      path: 'gestao-requisitar-cartoes-details',
      component: GestaoRequisitarCartoesDetailsComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['GESTAO_REQUISITAR_CARTOES']},
    },
    {
      path: 'restringir-mcc-produto',
      component: RestringirMccProdutoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['RESTRICAO_MCC'] }
    },
    {
      path: 'restringir-mcc-produto-cliente-cartao',
      component: RestringirMccProdutoClienteCartaoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['RESTRICAO_MCC'] }
    },
    {
      path: 'restringir-mcc-produto-cliente-cartao-edit',
      component: RestringirMccProdutoClienteCartaoEditComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['RESTRICAO_MCC'] }
    },
    {
      path: 'restringir-mcc-cliente',
      component: RestringirMccClienteComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['RESTRICAO_MCC'] }
    },
    {
      path: 'vale-estar-bem',
      loadChildren: () => import('./vale-estar-bem/vale-estar-bem.module')
        .then(m => m.ValeEstarBemModule),
    },
    {
      path: 'importar-cartao',
      component: ImportarCartaoComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['GESTAO_ONBOARDING']},
    },
  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class BackofficeRoutingModule { }

export const routedComponents = [
  BackofficeComponent,
  AlteracaoCadastralClienteComponent,
  GestaoUsuarioBackofficeComponent,
  CadastroUsuarioBackofficeComponent,
  AlteracaoUsuarioBackofficeComponent,
  AutorizarNovoDispositivoComponent,
  CriarSenhaTemporariaComponent,
  ExtratoContaBmpComponent,
  ExtratoContaOrbitalComponent,
  ConsultaFinanceiraComponent,
  GestaoOnboardingComponent,
  AprovacaoPixComponent,
  GestaoRequisitarCartoesComponent,
  ConsultaMovimentacoesPixComponent,
  RestringirMccProdutoClienteCartaoEditComponent,
  RestringirMccClienteComponent,
  ImportarCartaoComponent
];
